import {PlainDtoModel} from "../../../../../common/entity/dto/plain/plainDto.model";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {InsoleMaterialSummaryModel} from "../../../../material/api/entity/insoleMaterialSummary.model";
import {LovValue} from "../../../../../common/lov/lov-value/api/model/LovValue.model";

export class InsolesProviderModelGabaritModel implements PlainDtoModel{
    id: number;
    gabarit: LovValue;
    label: string;
    active: boolean;
}